var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['-transcribe-gap', '-gap', _vm.guid, { '-irrelevant': !_vm.isRelevant }],on:{"click":_vm.onClick}},[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }